<template>
    <div>
        <modal-wrapper modalClass="modal--form" :modalName="'evaluation-criteria'" @before-open="() => {}">
            <div class="modal__header">
                <h1>{{modal.title}}</h1>
            </div>
            <p class="line-breaks">{{modal.description}}</p>
        </modal-wrapper>
        <div class="panel">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-info"></i>
                    <span>{{evaluation.diploma.title}}</span>
                </h2>
            </div>
            <div class="panel__body" v-if="loading">
                <div class="spinner"></div>
            </div>
            <div v-else class="panel__body">
                <h2 class="panel__body__header">{{evaluation.work_process.title}}</h2>
                <p class="line-breaks">{{parseDescription(descriptions.description)}}</p>
                <label class="panel__label">{{$t('evaluations.role')}}</label>
                <p>
                    <span v-if="evaluation.evaluator_role">
                        {{$t('evaluations.roles.' + evaluation.evaluator_role.name) }}
                    </span>
                </p>
                <label class="panel__label">{{$t('evaluations.status')}}</label>
                <p>{{mapScoreToState(evaluation)}}</p>
                <hr>
                <label class="panel__label">{{$t('evaluations.evaluate_qualification')}}</label>
                <form @submit.prevent="saveEvaluation" class="form">
                    <div class="score_board">
                        <div class="score_board__col">
                            <div class="score_board__item">
                                <input type="radio" v-model="score" value="1" id="score_1" />
                                <label for="score_1">
                                    <i class="mdi" :class="[score == 1 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <span class="score_board__label_text">{{$t('evaluations.starter')}}</span>
                                </label>
                            </div>
                            <span class="score_board__info_btn" @click.prevent="showModal({title: $t('evaluations.starter'), description: descriptions.result_starter})">
                                <i class="icons icon-info"></i>
                            </span>
                        </div>
                        <div class="score_board__col">
                            <div class="score_board__item">
                                <input type="radio" v-model="score" value="2" id="score_2" />
                                <label for="score_2">
                                    <i class="mdi" :class="[score == 2 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <i class="mdi" :class="[score == 2 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <span class="score_board__label_text">{{$t('evaluations.advanced')}}</span>
                                </label>
                            </div>
                            <span class="score_board__info_btn" @click.prevent="showModal({title: $t('evaluations.advanced'), description: descriptions.result_advanced})">
                                <i class="icons icon-info"></i>
                            </span>
                        </div>
                        <div class="score_board__col">
                            <div class="score_board__item">
                                <input type="radio" v-model="score" value="3" id="score_3" />
                                <label for="score_3">
                                    <i class="mdi" :class="[score == 3 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <i class="mdi" :class="[score == 3 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <i class="mdi" :class="[score == 3 ? 'mdi-star' : 'mdi-star-outline']" ></i>
                                    <span class="score_board__label_text">{{$t('evaluations.professional')}}</span>
                                </label>
                            </div>
                            <span class="score_board__info_btn" @click.prevent="showModal({title: $t('evaluations.professional'), description: descriptions.result_professional})">
                                <i class="icons icon-info"></i>
                            </span>
                        </div>
                    </div>
                    <hr>
                    <div className="text-left"><strong>{{$t('evaluations.remarks')}}</strong></div>
                    <div class="form__item">
                        <textarea v-model="comments" class="form__input--text"></textarea>
                    </div>
                    <button type="submit" class="form__button button--cta">{{$t('evaluations.save_evaluation')}}</button>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>


.descriptions {
    font-size: 90%;
    width: 100%;
    margin-top: 2rem;
    display: flex;
}
</style>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch } from 'vue-property-decorator';
    import { GET_EVALUATION } from '@/store/modules/evaluation';
    import { GET_PENDING_EVALUATIONS } from '@/store/modules/pending-evaluations';
    import decode from 'jwt-decode';

    const getFirst = arr => arr && arr.length ? arr[0] : {};

    @Component()
    export default class EvaluationPanel extends Vue {
        name = 'evaluation-panel';
        score = 1;
        evaluation_id = 0;
        organisation_id = 0;
        diploma_id = 0;
        modal = false;
        loading = false;
        evaluation = { diploma: { title: 'Laden...' }, work_process: {} };
        descriptions = {
            description: '',
            result_starter: '',
            result_advanced: '',
            result_professional: '',
        };
        work_process = {};
        comments = '';


        mounted() {
            this.evaluation_id = this.$route.params.evaluation_id;
            this.descriptions = {
                description: '',
                result_starter: this.$t('evaluations.descriptions.starter'),
                result_advanced: this.$t('evaluations.descriptions.advanced'),
                result_professional: this.$t('evaluations.descriptions.professional'),
            };
            this.getEvaluationDetails();
        }

        mapScoreToState(evaluation) {
            if (evaluation.pending) return this.$t('evaluations.pending');
            if (parseInt(evaluation.score) === 1) return this.$t('evaluations.starter');
            if (parseInt(evaluation.score) === 2) return this.$t('evaluations.advanced');
            if (parseInt(evaluation.score) === 3) return this.$t('evaluations.professional');
        }

        showModal(content) {
            this.modal = content;
            this.$modal.show('evaluation-criteria');
        }

        // Regex to replace <br/> with line breaks and remove html tags, that might be included in the text as imported from SBB
        // Also replaces common characters from their HTML entity, with normal text
        parseDescription(desc) {
            if (desc) {
                desc = desc.replace(/<br[ ]?\/>/g, '\n');
                desc = desc.replace(/&amp;/g, '&');
                desc = desc.replace(/&lt;/g, '<');
                desc = desc.replace(/&gt;/g, '>');
                desc = desc.replace(/&quot;/g, '"');
                desc = desc.replace(/<(.*?)>/g, '');
            } else {
                desc = '-';
            }
            return desc;
        }

        @Watch('$route')
        onRouteChanged() {
            this.getEvaluationDetails();
        }

        getEvaluationDetails() {
            this.loading = true;
            const me = decode(this.$store.state.auth.token);

            Vue.axios.get(`account/${
                this.$route.params.user_id
            }/diplomas/${
                this.$route.params.diploma_id
            }/work-processes/${
                this.$route.params.work_process_id
            }/evaluations/${
                this.$route.params.evaluation_id
            }`).then(resp => {
                let evaluation = resp.data;
                this.evaluation = evaluation;
                this.work_process = evaluation.work_process;
                this.setCriteria(evaluation);
                this.score = evaluation.score < 1 ? 1 : evaluation.score;
                this.comments = evaluation.comments;
                this.descriptions = { ...this.descriptions, ...evaluation.work_process };
            }).catch(error => {
            }).then(() => this.loading = false);
        }

        setCriteria(evaluation) {
            this.descriptions.description = evaluation.work_process.description;

            Vue.axios.get(`account/${
                this.$route.params.user_id
            }/diplomas/${
                this.$route.params.diploma_id
            }/work-processes/${
                this.$route.params.work_process_id
            }/evaluations/${
                this.$route.params.evaluation_id
            }/work-process-description`)
                .then(resp => {
                    Object.keys(resp.data).map((key) => {
                        if (resp.data[key] == null) {
                            delete resp.data[key];
                        }
                    });
                    this.descriptions = Object.assign({}, this.descriptions, resp.data);
                });
        }

        saveEvaluation() {
            if (!this.evaluation_id) return;
            this.loading = true;
            Vue.axios.patch(`account/${
                this.$route.params.user_id
            }/diplomas/${
                this.$route.params.diploma_id
            }/work-processes/${
                this.$route.params.work_process_id
            }/evaluations/${
                this.evaluation_id
            }`, {
                score: this.score,
                comments: this.comments
            }).then(() => {
                return this.$router.push({ name: 'next-evaluation', params: { evaluation_id: this.evaluation_id } });
            })
                .catch(error => {
                    console.log(error);
                }).then(() => this.loading = false);
        }
    }

    Vue.component('evaluation-panel', EvaluationPanel);
</script>



// WEBPACK FOOTER //
// src/components/panels/profile/EvaluationPanel.vue